import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import Capsule from 'components/worten/capsule';


/*
  Standalone use of the loading spinner:

  import LoadingSpinner from 'contexts/loading-spinner/loading-spinner';
  const [showLoading, setShowLoading] = useState(false);
  setShowLoading(true);
  onError: ()=>setShowLoading(false)

  {showLoading && (
    <LoadingSpinner text='Procesando cambio...' bgOpacity={0.5}/>
  )}
*/




const Loading = ({ text, bgOpacity = 0}) => 
{
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: `rgba(0,0,0,`+bgOpacity+`)`,
        zIndex: 3000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      

      <Capsule sx={{
        width: 'fit-content',
        minWidth: '250px',
        height: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: 2,
      }}>
        <Box  sx={{ p:2, margin:'auto', textAlign:'center' }} >
          <CircularProgress/>
        </Box>
        
        <Typography variant="h4" sx={{ color:"text.secondary", margin:'auto' , pl:5, pr:5}}>
          {text}
        </Typography>
      </Capsule>
    </Box>
  );
};

export default Loading;
